import styled, { css } from 'styled-components';
import isOmpPlatform from '../../utils/isOmpPlatform';

const isOmp = isOmpPlatform();

const itemVariants = {
  disabled: css``,
  hoverable: css`
    &:hover {
      background-color: ${({ theme }) => theme.COLORS.NEUTRAL_5};
      color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    }
  `,
  clickable: css`
    cursor: pointer;
  `,
  selected: css`
    background-color: ${({ theme }) => theme.COLORS.NEUTRAL_5};
    color: ${({ theme }) => theme.COLORS.TERTIARY};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `
};

export const StyledFilterWrapper = styled.div`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: fit-content;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.COLORS.BASE};
  overflow: hidden;

  ${() =>
    !isOmp &&
    css`
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    `}

  ${() =>
    isOmp &&
    css`
      border: ${({ theme }) => `1px solid ${theme.COLORS.NEUTRAL_110}`};
      border-radius: 6px;
    `}
`;

export const StyledHeader = styled.div`
  width: 100%;
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  padding: 18px 12px 12px;
`;

export const StyledSelection = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  padding: 12px;

  ${({ onClick, disabled }) => onClick && !disabled && itemVariants.clickable}
  ${({ disabled }) => !disabled && itemVariants.hoverable}
  ${({ selected, disabled }) => !disabled && selected && itemVariants.selected}
`;
